const l={inline:"inline",stacked:"stacked"},a={small:"small",large:"large"};export{l as labelPositions,a as variants};
//# sourceMappingURL=select.types.js.map
